// extracted by mini-css-extract-plugin
module.exports = {"cls1":"FormLabel-CssProp1_Text-module--cls1--3vxLb","cls2":"FormLabel-CssProp1_Text-module--cls2--16Ubs FormLabel-CssProp1_Text-module--cls1--3vxLb"};